import ProductoRetail from "./ProductoRetail";

export default ProductoRetail;
